export default __webpack_public_path__ + "static/media/spei.effc6c7a.jpg";